"use strict";

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.weak-map");

require("core-js/modules/web.dom-collections.iterator");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.H6 = exports.H5 = exports.H4 = exports.H3 = exports.H2 = exports.H1 = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _space = _interopRequireDefault(require("../GlobalStyle/space/space"));

function _getRequireWildcardCache(nodeInterop) {
  if ("function" != typeof WeakMap) return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (null === obj || "object" != typeof obj && "function" != typeof obj) {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if ("default" != key && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

var heading = (0, _styledComponents.css)(["margin:0;letter-spacing:0;font-weight:700;", ""], function (props) {
  return props.color && (0, _styledComponents.css)(["color:", ";"], props.color);
});

var H1 = _styledComponents.default.h1.withConfig({
  displayName: "H1",
  componentId: "sc-stkh7p-0"
})(["", ";font-size:2.25rem;line-height:1.388888;@media (max-width:768px){font-size:2rem;line-height:1.375;}", ";", ";"], heading, _styledSystem.color, _space.default);

exports.H1 = H1;

var H2 = _styledComponents.default.h2.withConfig({
  displayName: "H2",
  componentId: "sc-stkh7p-1"
})(["", ";font-size:1.75rem;line-height:1.42857;@media (max-width:768px){font-size:1.625rem;line-height:1.384615;}", ";", ";"], heading, _space.default, _styledSystem.color);

exports.H2 = H2;

var H3 = _styledComponents.default.h3.withConfig({
  displayName: "H3",
  componentId: "sc-stkh7p-2"
})(["", ";font-size:1.375rem;line-height:1.363636;@media (max-width:768px){font-size:1.25rem;line-height:1.4;}", ";", ";", ""], heading, _space.default, _styledSystem.color, _styledSystem.typography);

exports.H3 = H3;

var H4 = _styledComponents.default.h4.withConfig({
  displayName: "H4",
  componentId: "sc-stkh7p-3"
})(["", ";font-size:1.125rem;line-height:1.444444;", ";", ";"], heading, _space.default, _styledSystem.color);

exports.H4 = H4;

var H5 = _styledComponents.default.h5.withConfig({
  displayName: "H5",
  componentId: "sc-stkh7p-4"
})(["", ";font-size:1rem;line-height:1.5;", ";", ";"], heading, _space.default, _styledSystem.color);

exports.H5 = H5;

var H6 = _styledComponents.default.h6.withConfig({
  displayName: "H6",
  componentId: "sc-stkh7p-5"
})(["", ";font-size:1rem;line-height:1.5;", ";", ";"], heading, _space.default, _styledSystem.color);

exports.H6 = H6;